import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface StickyCTAProps {
  onCheckout: () => void;
}
export function StickyCTA({
  onCheckout
}: StickyCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-197">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] p-4 pb-safe" data-id="element-198">
          <div className="flex items-center justify-between gap-3 max-w-md mx-auto tabular-nums" data-id="element-199">
            <div className="flex flex-col leading-none" data-id="element-200">
              <span className="text-[10px] text-gray-400 line-through font-medium tracking-tight mb-1" data-id="element-201">
                antes $50.000
              </span>
              <span className="text-lg font-bold text-black tracking-tight leading-none" data-id="element-202">
                Hoy <span className="text-terracotta" data-id="element-203">$17.990</span>
              </span>
            </div>
            <button onClick={onCheckout} className="bg-terracotta text-white font-bold uppercase tracking-wide py-3 px-5 rounded-sm shadow-premium active:scale-95 transition-transform text-xs whitespace-nowrap" data-id="element-204">
              QUIERO EL PACK
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}